import gsap from 'gsap'
import { forEach } from 'lodash'

import { batchRevealAnimation } from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const buttonsGroupRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const buttons = selector('[data-motion-button]')

  let buttonsBatchAnimation: ScrollTrigger[]
  if (buttons.length > 0) {
    buttonsBatchAnimation = batchRevealAnimation({
      targets: buttons,
      reverse,
      delay,
      stagger: {
        amount: 0.12
      }
    })
  }

  return () => {
    forEach(buttonsBatchAnimation || [], (animation) => animation.kill())
  }
}
